import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/StickyCTA.js
var StickyCTA = class {
  constructor(el, sel) {
    this.el = el;
    this.parent = el.closest("[data-sticky-cta-parent]");
    if (document.querySelector("[data-main-form]")) {
      this.mainCTA = document.querySelector("[data-main-form]");
    } else if (document.querySelector("[data-coming-soon]")) {
      this.mainCTA = document.querySelector("[data-coming-soon]");
    } else if (document.querySelector("[data-product-oos]")) {
      this.mainCTA = document.querySelector("[data-product-oos]");
    }
    if (this.parent) {
      this.el.addEventListener("click", () => {
        if (this.el.querySelector(".back-in-stock-anchor")) {
          document.querySelector(".klaviyo-bis-trigger").click();
        } else {
          this.mainCTA.querySelector("[data-main-cta-btn]").click();
        }
      });
      this.initOpacityInteractionObserver();
    } else {
      const BIS = this.el.querySelector(".back-in-stock-anchor");
      if (BIS) {
        BIS.addEventListener("click", () => {
          document.querySelector(".klaviyo-bis-trigger").click();
        });
      }
      this.initStandardInteractionObserver();
    }
  }
  initOpacityInteractionObserver() {
    const isMobile = window.innerWidth < 1024;
    if (isMobile) {
      this.parent.style.opacity = 1;
    }
    new IntersectionObserver(([entry]) => {
      if (isMobile)
        return;
      this.parent.style.opacity = entry.isIntersecting ? 0 : 1;
    }).observe(this.mainCTA);
  }
  initStandardInteractionObserver() {
    if (this.mainCTA) {
      new IntersectionObserver(([entry]) => {
        this.el.classList.toggle("active", !entry.isIntersecting);
      }).observe(this.mainCTA);
    }
  }
};
var StickyCTA_default = StickyCTA;
export {
  StickyCTA_default as default
};
